import { createTheme } from "@mui/material/styles";

// Peter Drew brand palette. These are the only places these hex values should
// appear; everything else refers to them through the theme.
const brand = {
  blue: "#3095B4",
  orange: "#E98300",
  slate: "#394A58",
  ink: "#1E1E1E",
  paper: "#F6F6F6",
  green: "#A5D867",
  violet: "#7E57C2",
};

// The app accents with blue on light and orange on dark. Expressing that as a
// per-scheme `primary` means components ask for `primary.main` rather than
// branching on `palette.mode`. `error` is left as the MUI default red.
//
// `entitlement` is a category marker for the dashboard tiles rather than an
// accent, so unlike primary/secondary it holds still across both schemes.
export const theme = createTheme({
  // `colorSchemeSelector: "data"` scopes the scheme's variables to a
  // `data-light`/`data-dark` attribute on <html>, which the account menu's
  // useColorScheme() sets.
  cssVariables: { colorSchemeSelector: "data" },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: brand.blue },
        secondary: { main: brand.orange },
        success: { main: brand.green },
        entitlement: { main: brand.violet },
        background: { default: brand.paper, paper: "#FFFFFF" },
        text: { primary: brand.ink, secondary: brand.slate },
      },
    },
    dark: {
      palette: {
        primary: { main: brand.orange },
        secondary: { main: brand.blue },
        success: { main: brand.green },
        entitlement: { main: brand.violet },
      },
    },
  },
  shape: { borderRadius: 8 },
  // Raleway's x-height is small, so it reads a size smaller than Roboto did at
  // the same value. Only the family is set; the scale stays MUI's.
  typography: {
    fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
  },
});
